exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js?minimize!swiper/dist/css/swiper.css"), "");

// module
exports.push([module.id, "\n[data-v-27d306f0] .swiper-pagination-bullets{left:50%;-webkit-transform:translateX(-50%) !important;-ms-transform:translateX(-50%) !important;transform:translateX(-50%) !important;white-space:nowrap\n}\n[data-v-27d306f0] .swiper-pagination-bullets .swiper-pagination-bullet{margin:0 0.11111rem\n}\n.swiper-container[data-v-27d306f0],.swiper-wrapper[data-v-27d306f0]{width:100%;height:100%\n}\n", ""]);

// exports
